import { render } from "./List.vue?vue&type=template&id=008c80d6&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=008c80d6&lang=scss"
import "./List.vue?vue&type=style&index=1&id=008c80d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008c80d6"]])

export default __exports__